module.exports = __webpack_public_path__ + "static/media/adventureForrestIcon.8feacfa6.png";